import { render, staticRenderFns } from "./tarif-consommable.html?vue&type=template&id=35def181&scoped=true&external"
import script from "./tarif-consommable.js?vue&type=script&lang=js&external"
export * from "./tarif-consommable.js?vue&type=script&lang=js&external"
import style0 from "./tarif-consommable.scss?vue&type=style&index=0&id=35def181&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35def181",
  null
  
)

export default component.exports